import Animation from '../../animations/animation'
import AreaStackTransformer from '../transformers/area-stack-transformer'

/*
 * Turns a stack into a normal area chart
 */
class RemoveInnerStack extends Animation {

  constructor (options) {
    super(options)
    this.transformer = new AreaStackTransformer({
      styles: this.styles,
      exitingSeries: this.exitingSeries,
      series: this.series
    })
  }

  match (serie) {
    let exitingSeries = this.exitingSeries.selection().data()
      , exitingStack = exitingSeries.length && exitingSeries.every(serie => serie.stackBy)
      , allSeries = this.series.selection().data()
      , oldSeries = this.previous.series.data()
      , newSeries = allSeries.filter(serie => !oldSeries.includes(serie))

    return this.seriesChanged &&
           this.previous.scalers.x && // an update
           exitingStack && // all series exiting were in a stack
           newSeries.length === 1 // One new serie
  }

  animate (serie, entering, selection, merged, exiting) {
    if (entering.size()) {
      this._initialInsert(entering) // Get the elements in the DOM
    }

    return this.transformer.transform(serie, entering, selection, merged, exiting)
  }

}

export default RemoveInnerStack

